var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculatorOutputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 7.76471,
    fill: "#2F736E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4470_58953",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 7.76471,
    fill: "#2F736E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4470_58953)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4470_58953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3841 8.625H10.8008C9.07474 8.625 7.67578 10.024 7.67578 11.75V21.125C7.67578 22.851 9.07474 24.25 10.8008 24.25H25.3841C27.1102 24.25 28.5091 22.851 28.5091 21.125V11.75C28.5091 10.024 27.1102 8.625 25.3841 8.625Z",
    fill: "url(#paint0_linear_4470_58953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2174 28.4173H14.9674C14.3924 28.4173 13.9258 27.9507 13.9258 27.3757C13.9258 26.8007 14.3924 26.334 14.9674 26.334H21.2174C21.7924 26.334 22.2591 26.8007 22.2591 27.3757C22.2591 27.9507 21.7924 28.4173 21.2174 28.4173Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1764 23.209H16.0098V27.3757H20.1764V23.209Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3841 24.25H10.8008C9.07474 24.25 7.67578 22.851 7.67578 21.125H28.5091C28.5091 22.851 27.1102 24.25 25.3841 24.25Z",
    fill: "#20302F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3431 12.6848V13.8337H20.6973C19.8348 13.8337 19.1348 14.5337 19.1348 15.3962C19.1348 16.2587 19.8348 16.9587 20.6973 16.9587H24.3431V18.1077C24.3431 18.7994 25.1358 19.19 25.6837 18.7681L29.2118 16.0567C29.6462 15.7233 29.6462 15.0692 29.2118 14.7348L25.6837 12.0233C25.1358 11.6025 24.3431 11.9942 24.3431 12.6848Z",
    fill: "#20302F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4470_58953",
    x: -4.27182,
    y: -4.3646,
    width: 44.7292,
    height: 44.7292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.9323
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.533333 0 0 0 0 0.890196 0 0 0 0 0.866667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4470_58953"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4470_58953",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4470_58953",
    x1: 14.4466,
    y1: 8.625,
    x2: 24.5306,
    y2: 34.3106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D6366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorOutputIcon);
export default __webpack_public_path__ + "static/media/calculator-output-icon.e2447e3cc9f096f0cc707290537e708c.svg";
export { ForwardRef as ReactComponent };